import { styled } from "@mui/material";

export const Container = styled("div")(({ theme }) => ({
  height: "100%",
  "& canvas": {
    borderRadius: theme.shape.borderRadius,
  },
}));
